import { createFileRoute } from "@tanstack/react-router";
import { BrandingSettingsPage } from "@/features/tenant-settings/pages/branding-settings-page";

export const Route = createFileRoute("/_authed/tenants/$slug/settings/branding")({
  component: BrandingSettingsPage,
});
